import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, API, formatApiError } from "@/lib/api";
import { PdfPicker } from "./PdfPicker";

export const CompcardDialog = ({ model, onClose, onSaved }) => {
  const [sel, setSel] = useState({ cover: model.pdf_cover || "", grid: model.pdf_grid || [] });
  const [busy, setBusy] = useState(false);

  const save = async (reset = false) => {
    setBusy(true);
    try {
      await api.put(`/admin/compcards/${model.id}`, reset ? { pdf_cover: "", pdf_grid: [] } : { pdf_cover: sel.cover, pdf_grid: sel.grid });
      toast.success(reset ? "Tornata alla scelta automatica" : "Compcard salvata");
      onSaved();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="compcard-dialog" data-lenis-prevent className="max-h-[90vh] max-w-3xl overflow-y-auto rounded-none bg-white">
        <DialogHeader><DialogTitle className="font-display text-4xl uppercase">{model.name}</DialogTitle></DialogHeader>
        <PdfPicker images={model.images} cover={sel.cover || model.cover} grid={sel.grid} onChange={({ cover, grid }) => setSel({ cover, grid })} />
        <div className="mt-4 grid gap-3 sm:grid-cols-3">
          <button disabled={busy} onClick={() => save()} data-testid="compcard-save" className="bg-[#1c1418] py-4 font-mono text-xs uppercase tracking-[0.2em] text-white disabled:opacity-60">Salva</button>
          <button disabled={busy} onClick={() => save(true)} data-testid="compcard-reset" className="border border-[#1c1418] py-4 font-mono text-xs uppercase tracking-[0.2em]">Scelta automatica</button>
          <a href={`${API}/models/${model.slug}/composite.pdf`} data-testid="compcard-preview" className="grid place-items-center border border-[#1c1418]/30 py-4 font-mono text-xs uppercase tracking-[0.2em]">Scarica PDF</a>
        </div>
      </DialogContent>
    </Dialog>
  );
};
